var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppleIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.144 15.586a10.843 10.843 0 0 1-1.085 1.933c-.57.807-1.038 1.365-1.398 1.674-.558.509-1.156.77-1.797.784-.46 0-1.014-.13-1.659-.392-.647-.262-1.242-.392-1.786-.392-.571 0-1.183.13-1.837.392-.656.263-1.184.4-1.588.413-.614.026-1.226-.242-1.837-.805-.39-.337-.878-.914-1.462-1.733-.627-.874-1.142-1.888-1.546-3.043C.717 13.169.5 11.96.5 10.79c0-1.34.292-2.496.878-3.465a5.125 5.125 0 0 1 1.838-1.842A4.979 4.979 0 0 1 5.7 4.788c.488 0 1.127.15 1.922.443.793.295 1.302.444 1.525.444.166 0 .732-.175 1.69-.523.907-.323 1.671-.457 2.298-.404 1.698.135 2.974.799 3.822 1.994-1.518.912-2.27 2.189-2.255 3.827.014 1.276.481 2.338 1.4 3.181a4.6 4.6 0 0 0 1.397.909c-.112.322-.23.63-.356.927ZM13.249.4c0 1-.368 1.934-1.103 2.799-.887 1.027-1.96 1.621-3.124 1.527A3.087 3.087 0 0 1 9 4.347c0-.96.422-1.987 1.17-2.828A4.52 4.52 0 0 1 11.597.458C12.173.18 12.717.026 13.229 0c.015.134.021.267.021.4Z"
  })));
};
export default SvgAppleIcon;